import { render } from "./OidoPage.vue?vue&type=template&id=7b5fd559&scoped=true"
import script from "./OidoPage.vue?vue&type=script&lang=js"
export * from "./OidoPage.vue?vue&type=script&lang=js"

import "./OidoPage.vue?vue&type=style&index=0&id=7b5fd559&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5fd559"]])

export default __exports__